/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AggiornamentoEventoCalendarioStudente } from './aggiornamentoEventoCalendarioStudente';
import { EventoCalendarioDTOType } from './eventoCalendarioDTOType';
import { EventoCalendarioStatus } from './eventoCalendarioStatus';

export interface EventoCalendarioDTO { 
    id?: string;
    data?: string;
    tipo?: EventoCalendarioDTOType;
    motivazione?: string;
    stato?: EventoCalendarioStatus;
    aggiornamenti?: Array<AggiornamentoEventoCalendarioStudente>;
    descrizione?: string;
}